export const supportEmail = "support@gtdiag.com";

export const BASE_URL = "https://study-configuration.prod2.hipal-app.com";
